import { render, staticRenderFns } from "./POIWidgetEdit.vue?vue&type=template&id=773c30c8"
import script from "./POIWidgetEdit.js?vue&type=script&lang=js&external"
export * from "./POIWidgetEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports